module.exports = __webpack_public_path__ + "img/approved.43dd32f2.svg";